
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workerscompensationrates/privacy-policy",
      function () {
        return require("private-next-pages/workerscompensationrates/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/workerscompensationrates/privacy-policy"])
      });
    }
  